<template>
  <svg
    width="541"
    height="78"
    viewBox="0 0 541 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3842:441"
      style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="134"
      y="0"
      width="20"
      height="19"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M134.269 0H153.074V18.8095H134.269V0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3842:441)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M153.074 9.41025C153.074 14.5936 148.868 18.81 143.683 18.81C138.493 18.81 134.269 14.5936 134.269 9.41025C134.269 4.21255 138.493 -0.000244141 143.683 -0.000244141C148.868 -0.000244141 153.074 4.21255 153.074 9.41025Z"
        fill="#FF9600"
      />
    </g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 22.8654H16.2114V30.2252C18.5532 27.1698 20.9148 24.9897 23.2818 23.6975C25.6578 22.3873 28.5316 21.7493 31.8925 21.7493C35.5086 21.7493 38.3807 22.4592 40.4853 23.8808C42.5971 25.3079 44.3027 27.425 45.6506 30.2252C48.3951 26.9416 50.9022 24.713 53.1524 23.5142C55.4098 22.3424 58.1956 21.7493 61.5079 21.7493C66.3947 21.7493 70.2049 23.3506 72.9439 26.5498C75.692 29.7669 77.0579 34.7615 77.0579 41.5749V73.126H59.6406V44.5386C59.6406 42.2705 59.247 40.5972 58.4364 39.4811C57.27 37.7504 55.7926 36.8984 54.0403 36.8984C51.9698 36.8984 50.3019 37.7162 49.0421 39.3409C47.7714 40.989 47.1531 43.6148 47.1531 47.2309V73.126H29.7142V45.5002C29.7142 43.2769 29.6208 41.7834 29.3817 41.0088C29.0259 39.7309 28.3825 38.7209 27.4623 37.9427C26.5582 37.1788 25.4817 36.796 24.2541 36.796C22.261 36.796 20.6237 37.6227 19.344 39.287C18.0697 40.9603 17.4227 43.7065 17.4227 47.5059V73.126H0V22.8654Z"
      fill="black"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M131.968 50.5685C131.968 43.9491 130.974 38.5825 129.01 34.4667C127.058 30.333 124.195 27.1788 120.43 25.0131C116.672 22.833 111.548 21.7493 105.054 21.7493C97.0687 21.7493 90.7837 24.181 86.2402 29.0408C81.7003 33.8916 79.4268 40.2414 79.4268 48.0936C79.4268 53.5969 80.5662 58.4028 82.8272 62.4987C85.0935 66.5642 87.9404 69.5494 91.3858 71.433C94.8311 73.2967 99.5508 74.2295 105.564 74.2295C112.471 74.2295 117.788 73.1422 121.477 70.9459C125.173 68.755 128.338 65.1425 130.962 60.0958L113.819 58.3021C112.73 59.819 111.731 60.8884 110.798 61.4923C109.252 62.4538 107.646 62.9337 105.942 62.9337C103.242 62.9337 101.068 61.8499 99.38 59.6609C98.1956 58.1368 97.4336 55.8309 97.1245 52.7396H131.968V50.5685ZM97.1727 43.5543C97.4495 40.5511 98.1181 38.3117 99.1731 36.7984C100.812 34.3703 103.032 33.1571 105.785 33.1571C108.185 33.1571 110.102 33.9605 111.563 35.56C113.017 37.1794 113.932 39.834 114.274 43.5543H97.1727Z"
      fill="black"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M152.249 22.8678V73.1284H134.819V22.8678C134.819 22.8678 138.426 24.9472 143.656 24.9472C148.897 24.9472 152.249 22.8678 152.249 22.8678Z"
      fill="black"
    />
    <mask
      id="mask1_3842:441"
      style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="740"
      height="75"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 74.4231H739.97V0H0V74.4231Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_3842:441)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M158.046 73.1266H175.464V3.79517H158.046V73.1266Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M181.361 73.1266H198.787V3.79517H181.361V73.1266Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M254.47 50.5685C254.47 43.9491 253.486 38.5825 251.54 34.4667C249.563 30.333 246.714 27.1788 242.936 25.0131C239.178 22.833 234.054 21.7493 227.563 21.7493C219.565 21.7493 213.292 24.181 208.751 29.0408C204.221 33.8916 201.944 40.2414 201.944 48.0936C201.944 53.5969 203.073 58.4028 205.336 62.4987C207.6 66.5642 210.451 69.5494 213.893 71.433C217.342 73.2967 222.068 74.2295 228.066 74.2295C234.98 74.2295 240.294 73.1422 243.986 70.9459C247.687 68.755 250.861 65.1425 253.476 60.0958L236.328 58.3021C235.242 59.819 234.239 60.8884 233.314 61.4923C231.761 62.4538 230.154 62.9337 228.447 62.9337C225.749 62.9337 223.564 61.8499 221.894 59.6609C220.702 58.1368 219.951 55.8309 219.631 52.7396H254.47V50.5685ZM219.683 43.5543C219.958 40.5511 220.632 38.3117 221.684 36.7984C223.335 34.3703 225.539 33.1571 228.29 33.1571C230.674 33.1571 232.609 33.9605 234.085 35.56C235.537 37.1794 236.439 39.834 236.781 43.5543H219.683Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M304.488 73.1284H288.225V64.985C285.802 68.3153 283.361 70.6823 280.895 72.113C278.447 73.5202 275.412 74.2301 271.83 74.2301C267.051 74.2301 263.295 72.6629 260.597 69.4872C257.874 66.315 256.512 61.4264 256.512 54.8394V22.8678H274.026V50.4972C274.026 53.6496 274.546 55.889 275.588 57.21C276.645 58.5292 278.099 59.2014 280.007 59.2014C282.078 59.2014 283.767 58.3225 285.086 56.5612C286.397 54.7765 287.071 51.6043 287.071 47.0339V22.8678H304.488V73.1284Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M309.441 22.8654H325.746V31.0969C327.317 27.5365 328.927 25.0796 330.597 23.755C332.27 22.4214 334.317 21.7493 336.772 21.7493C339.334 21.7493 342.127 22.6191 345.193 24.3751L339.801 38.1116C337.75 37.1644 336.136 36.672 334.932 36.672C332.657 36.672 330.885 37.7198 329.646 39.8136C327.845 42.7539 326.943 48.2338 326.943 56.2784V73.126H309.441V22.8654Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M364.701 3.79517V22.866H374.278V36.9961H364.701V54.7711C364.701 56.9027 364.857 58.3207 365.252 59.0073C365.809 60.0712 366.803 60.6158 368.23 60.6158C369.514 60.6158 371.318 60.2006 373.626 59.3937L374.913 72.6665C370.599 73.7161 366.593 74.2283 362.869 74.2283C358.532 74.2283 355.346 73.628 353.288 72.4005C351.241 71.1676 349.722 69.2966 348.737 66.802C347.752 64.311 347.265 60.2546 347.265 54.6399V36.9961H340.887V22.866H347.265V13.6496L364.701 3.79517Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M395.195 34.6644C396.622 33.658 398.75 33.1565 401.609 33.1565C403.813 33.1565 405.362 33.6148 406.245 34.5836C407.134 35.5163 407.567 37.1644 407.567 39.5099C405.403 40.4678 403.358 41.2209 401.433 41.8068C399.487 42.3963 395.252 43.4207 388.764 44.8729C383.315 46.0771 379.591 47.8887 377.567 50.36C375.551 52.8169 374.546 55.9693 374.546 59.7867C374.546 63.8701 375.943 67.2938 378.75 70.0688C381.554 72.8456 385.659 74.2295 391.056 74.2295C395.118 74.2295 398.691 73.5322 401.766 72.1591C404.011 71.1148 406.273 69.3877 408.554 66.9614C408.759 68.4153 408.944 69.4847 409.145 70.1767C409.348 70.8435 409.764 71.8248 410.436 73.126H426.8C425.889 71.0465 425.294 69.3248 425.012 67.9966C424.755 66.6558 424.62 64.8046 424.62 62.4286V40.2486C424.62 37.8798 424.206 35.3941 423.322 32.7935C422.476 30.191 421.324 28.1799 419.832 26.7636C417.733 24.713 415.091 23.3686 411.933 22.7198C408.764 22.0674 404.578 21.7493 399.363 21.7493C396.115 21.7493 393.096 22.0099 390.301 22.5562C387.508 23.0828 385.333 23.8431 383.725 24.819C381.509 26.1688 379.812 27.7647 378.626 29.6069C377.443 31.4581 376.545 33.9725 375.912 37.1878L392.512 39.1145C393.196 36.9506 394.095 35.457 395.195 34.6644ZM407.567 52.2835C407.567 54.6864 407.215 56.6526 406.525 58.139C405.811 59.6613 404.636 60.9283 402.975 61.9671C401.322 63.0042 399.54 63.538 397.585 63.538C395.752 63.538 394.334 63.0509 393.394 62.0948C392.447 61.1224 391.961 59.8985 391.961 58.3618C391.961 57.0444 392.454 55.86 393.419 54.8068C394.354 53.7968 396.584 52.7651 400.099 51.7209C402.695 51.002 405.177 50.1537 407.567 49.2029V52.2835Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M477.084 73.1284H460.828V64.985C458.407 68.3153 455.952 70.6823 453.511 72.113C451.041 73.5202 448.015 74.2301 444.437 74.2301C439.659 74.2301 435.9 72.6629 433.198 69.4872C430.474 66.315 429.118 61.4264 429.118 54.8394V22.8678H446.635V50.4972C446.635 53.6496 447.154 55.889 448.193 57.21C449.248 58.5292 450.714 59.2014 452.616 59.2014C454.685 59.2014 456.379 58.3225 457.695 56.5612C459.011 54.7765 459.667 51.6043 459.667 47.0339V22.8678H477.084V73.1284Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M480.851 22.8678H501.473L508.711 36.8721L517.158 22.8678H536.301L520.824 46.8038L537.401 73.1284H517.054L508.711 56.935L498.9 73.1284H480.034L496.491 46.8038L480.851 22.8678Z"
        fill="black"
      />
    </g>
  </svg>
</template>
